import React from "react";
import AdminPageContainer from "../components/AdminPageContainer";
import InfluencerTermsManager from "./InfluencerTermsManager";

export default function InfluencerTerms() {
  return <AdminPageContainer><InfluencerTermsManager /></AdminPageContainer>;
}
